const MESSAGES_PER_BATCH = 30
const MINUTES_PER_BATCH_INTERVAL = 2
const INITIAL_SEND_BUFFER_MINUTES = 2

/**
 * Approximate minutes left to finish sending, based on remaining messages.
 * Batches of 30 with 2-minute intervals, plus up to 2 minutes for the current send.
 */
export function getApproxMinutesRemaining(deliveryRemaining) {
  if (deliveryRemaining == null || Number.isNaN(Number(deliveryRemaining))) {
    return 0
  }

  const remaining = Math.max(0, Number(deliveryRemaining))
  if (remaining === 0) {
    return 0
  }

  return (
    Math.floor(remaining / MESSAGES_PER_BATCH) * MINUTES_PER_BATCH_INTERVAL +
    INITIAL_SEND_BUFFER_MINUTES
  )
}
